export const LOGIN_URL = "/login";
export const PASSWORD_RESET = "/login/reset";
export const PASSWORD_VERIFY_RESET = "/login/reset/user";
export const BUY_VOUCHER = "/charge/voucher";
export const VERIFY_PAYMENT_BUY_URL = "/charge/voucher/verify";
export const VERIFY_EMAIL = "/login/verify/user";
export const VERIFY_BUSINESS_EMAIL = "/login/verify/business";
export const CHARGE_REQUEST_URL = "/charge/request";
export const FUND_ACCOUNT_URL = "/wallet/fund";
export const GET_STERLING_WALLET_URL = "/external/balance";
export const TRANSFER_STERLING_URL = "/wallet/external/transfer";
export const GET_TRANSFER_META_URL = "/wallet/external/transfer";
export const GET_TRANSFER_Bank_URL = "/wallet/external/banks";
export const SETUP_PAYMENT_PIN_URL = "/wallet/pin/setup";
export const VERIFY_WALLET_RECIPIENT_URL = "/wallet/recipient/verify";
export const TRANSFER_PREVIEW_URL = "/wallet/external/transfer/preview";
export const STERLING_HISTORY_URL = "/wallet/external/history";
export const VERIFY_BANK_ACCOUNT_URL = "/wallet/external/account/verify";

export const REGISTER_URL = "/user/register";
export const REGISTER_PARTNER_URL = "/business/register";
export const SEND_INVITE_URL = "/business/invite";
export const SEND_UNINVITE_URL = "/business/uninvite";
export const VERIFY_INVITE_URL = "/business/invite/verify";
export const GET_CHANNELS_URL = "/business/channels";
export const GET_BUSINESS_MANAGERS_URL = "/business/managers";
export const GET_BUSINESS_USERS_EXPORT_URL = "/business/users/export";
export const VERIFY_PAYMENT_URL = "/charge/verify";
export const GET_PASTQUESTIONS_URL = "/pastquestions";
export const GET_ANALYSIS_URL = "/pastquestions/analysis/index";
export const GET_ANALYSIS_TOPIC_URL = "/pastquestions/analysis/topic/index";
export const GET_FLAGGED_ANALYSIS_URL = "/pastquestions/flagged/analysis/index";
export const TOGGLE_FLAGGED_ANALYSIS_URL = "/pastquestions/flagged/analysis/toggle";
export const GET_ANALYSIS_DATA_URL = "/pastquestions/analysis/data";
export const GET_TEST_VERIFY_URL = "/pastquestions/verify";
export const TOGGLE_TEST_PIN_URL = "/pastquestions/pin";
export const GET_COUNTRIES_URL = "/pastquestions/countries/index";
export const SEND_COUNTRIES_URL = "/pastquestions/countries/set";
export const MARK_ATTEMPTED_URL = "/pastquestions/attempt";
export const VERIFY_GOOGLE_USER = "/login/verifyGoogleAuth";
export const DEFAULT_ERROR = "Service Unavailable";
export const SUBMIT_ERROR = [
    'Test Duration Elapsed',
];
export const GET_USERS_ADMIN_URL = "/admin/users";
export const GET_ADMIN_URL = "/admin";
export const GET_ADMIN_BUSINESS_OVERVIEW_URL = "/admin/business-overview";
export const GET_EMAIL_SENT_URL = "/admin/emails";
export const SEND_EMAIL_URL = "/admin/emails";
export const GET_ALL_BUSINESSES_URL = "/admin/businesses";
export const LOCK_TEST_BUSINESS_URL = "/pastquestions/lock";
export const GET_BUSINESS_URL = "/business";
export const GET_TOPUP_BUSINESS_URL = "/business/topup/users";
export const GET_TOPUP_ACTIVITY_BUSINESS_URL = "/business/topup/activity";
export const GET_BLOGS_URL = "/blogs";
export const GET_BLOGS_EMAIl_URL = "/blogs/email";
export const UNAUTHENTICATED_URLs = [
    "/login",
    "/buy-voucher",
    "/password-reset",
    "/login/verify/user",
    "/login/verify/business",
    "/login/reset/user",
    "/authenticate",
    "/authenticate-business",
    "/partnership",
    "/unauthorized",
    "/signup/invite/:id",
    "/login/invite/:id",
    "/main-news/:blog_id",
    "/news-page",
];

export const ADMIN_ROLES = [
    2000
    ];
export const BUSINESS_ROLES = [
    3000
];

export const randomIntFromInterval = (min, max) => { // min and max included
    return Math.floor(Math.random() * (max - min + 1) + min);
}

export const getRandomSeconds = () => { // min and max included
    return [0,500,1000,1500,2000,2500,3000,3500][randomIntFromInterval(0,7)];
}
